<template>
  <div class="news1">
    <p>前几年，我公司在全国纺织行业不景气的情况下，靠给南方某企业来料加工大比例涤纶混纺针织纱T/R 98/02  13 tex，T/R 95/05 13 tex，使得企业得以正常运行生产。其中T/R98/02 13tex占我公司新纺分厂锭数的52%，T/C95/05 13tex占老纺分厂锭数的36%，这里主要介绍生产T/R 98/02 13 tex时所遇到的几个问题及解决措施。</p>
    <br><p><b>1 原材料</b></p>
    <p>大比例涤纶混纺纱使用原料见表1。</p>
    <p style="color: #999; text-align: center">表1  原料部分性能指标</p>
    <p><img src="../../assets/img/news10-1.jpg"/></p>
    <br><p><b>2 工艺流程</b></p>
    <p>大比例涤纶混纺纱生产工艺流程如下:</p>
    <p>A002D型自动抓棉机→A006B型自动混棉机→A036B型豪猪式开棉机→A092A型棉箱给棉机→A076C型单打手成卷机→A186 F型梳棉机→FA302型并条机(三道)→A454 E型粗纱机-→FA503型细纱机→1332MD型络筒机→成包</p>
    <br><p><b>3 工艺参数调整与主要工序质量控制</b></p>
    <p>3.1 清花与梳棉工序</p>
    <p>(1)其品种含粘胶成分只有2%，配放在涤纶盘中使用。由于涤纶纤维回潮小，开包后比较蓬松，而粘胶纤维回潮较大，松包后较板结。这样的差异，易造成抓棉打手抓取成分不均匀，影响了其配比。因此，在粘胶上盘前先人工松包，开车时多巡回观察，按平涤，松粘胶，尽量保持成分的一致性。</p>
    <p>(2)开清棉主要打手速度适当减慢，卷子伸长在-1.0%以下，纤维卷均匀度较稳定。</p>
    <p>(3)梳棉主要工艺措施是梳理速度减慢，梳理隔距相应放大，以免损伤纤维。锡林速度330r/min，刺辊速度980r/ min，锡林~刺辊隔距0.23 mm，锡林~盖板隔距 0.35 mm、0.30 mm、0.30 mm、0.30 mm、0. 35 mm。生条重不匀控制在4.2%以下为宜。</p>
    <p>3.2 并条与粗纱工序</p>
    <p>(1)为了进一步均匀并合，并条采用三道，由于涤纶纤维和粘胶纤维整齐度较好，后区牵伸配置过小时，纤维易在胶辊罗拉间滑移，因此，后区隔距适当放大，以减缓前牵伸力，减少条子中硬块的形成。</p>
    <p>(2)粗纱捻系数和其他工艺参数要合理选配。粗纱定量4.66g/mm，粗纱捻系数59，前后区罗拉隔距选为26mmx31mm，后区牵伸倍数1.22。</p>
    <p>粗纱条干CV值在4.0%以下，重不匀1.0%，小纱伸长率偏小掌握。</p>
    <p>3.3 细纱工序</p>
    <p>（1）根据须条中主体成分涤纶纤维的特性，为减缓前区牵伸力，适当放大后区隔距，考虑到成品是针织用纱，采用较小的后牵伸倍数。主要工艺配置：前后区罗拉隔距19mmx29mm，后牵伸倍数1.25。</p>
    <p>(2) 在正常生产时，钢领、钢丝圈要合理配套使用，但钢丝圈仍易发热、发黑，检查时磨损有伤痕，缩短钢丝圈调换周期，,原7天换一次改为5天换一次，每天专人巡回检查，发现钢领跑道发黑。及时调换。</p>
    <p>(3) 在生产中，发现纺出的纱捻度CV值极不稳定，有的高达5.7%~5.8%以上，主要是主体成分涤纶纤维弹性大，有一定的抗扭性，加捻效率低和其他因素的影响。为此，我们对每台车进行测试，发现锭差大，且不稳定，于是从减少锭差着手，选用质量稳定的宽锭带，严格控制锭带长度，剔除磨损筒管。每天专人巡查消灭歪锭、摇头或麻手锭，锭胆缺油等现象，同时，锭速不能过高。经过以上一些问题的解决。捻度CV值有了好转，保证了成纱质量的稳定。</p>
    <p>3.4  后加工工序</p>
    <p>络筒工序中槽筒速度不能过快，否则筒子转动不平衡，不规则撞击槽筒，容易磨伤纱的表面，影响强力。另外，纱的张力过大也会导致断头急剧增加。还有张力片重量配置也须谨慎。用户刚开始使用时，反映个别筒子织造断头高，经倒纱检查，触摸筒子两端发硬，说明张力太大，后适当减张力片重量，再倒纱时，不正常断头就很少了，成纱质量趋于正常。</p>
    <p>通过以上一系列整修措施和适当的工艺调整，该品种质量稳定，在2019年9月乌斯特条干抽测时，各项指标为：条干CV值14.64%，细节40个/1000 m，粗节71个/1000m，棉结55个/1000m。其他试验测试指标：单纱断裂强度27.6cN/tex，单纱强力变异系数10.8%，捻度变异系数5.3%，其他指标均达到国家一等纱的要求。</p>
    <p style="color: #999; text-align: center">来源：TTEB</p>
  </div>

</template>
<script>
  export default {
    name: 'news10'
  }
</script>

<style scoped>
  .news1{
    text-align: left;
    font-size: 18px;
    line-height: 200%;
    background: #fff;
    color: #333;
    margin-top: -10px;
    padding: 20px 30px;
  }

  .news1 p{
    font-family: 微软雅黑;
    text-indent: 2em;
    line-height: 145%;
    margin: 12px 0;
  }

  .news1 p img{
    display: block;
    max-width: 100%;
    margin: 12px auto;
  }

</style>



// WEBPACK FOOTER //
// src/views/new/news10.vue